// Shared, dependency-free profile. Participants and approval order remain DB-driven.
const CATEGORY = 'report_annulment';
const ACTIONS = ['submit', 'approve', 'reject', 'return', 'cancel', 'save', 'comment'];
const isAnnulment = type => Boolean(type && (type.category === CATEGORY ||
    (type.workflow_config || {}).domain === CATEGORY || (type.workflow_data || {}).domain === CATEGORY));
function normalizeWorkflow(value, allowComments = true) {
    const config = JSON.parse(JSON.stringify(value || {}));
    Object.assign(config, {domain: CATEGORY, allowedActions: ACTIONS.filter(action => action !== 'comment' || allowComments), requiredRoles: ['initiator', 'approver'],
        optionalRoles: ['observer'], requiresAcceptance: false, requiresBuildingProcess: true,
        autoTransitions: {}, sequentialApproval: config.sequentialApproval !== false,
        buildingProcess: {enabled: true, required: true}, requestEditing: {editorRoles: ['initiator']},
        stateMachineConfig: {
            transitionsMap: {draft: ['submitted', 'cancelled'], returned: ['submitted', 'cancelled'],
                submitted: ['in_review', 'completed', 'rejected', 'returned', 'cancelled'],
                in_review: ['in_review', 'completed', 'rejected', 'returned', 'cancelled'],
                completed: [], rejected: [], cancelled: []},
            actionPermissions: {submit: ['initiator'], approve: ['approver'], reject: ['approver'],
                return: ['approver'], cancel: ['initiator'], save: ['initiator'],
                comment: allowComments ? ['initiator', 'approver', 'observer'] : []},
            actionConstraints: {save: {allowedStatuses: ['draft', 'returned']}},
            actionToStatus: {submit: 'submitted', approve: 'completed', reject: 'rejected', return: 'returned', cancel: 'cancelled'},
            customLogic: {approve: {fromSubmitted: 'in_review', hasPendingApprovers: 'in_review', allApproved: 'completed'}}
        }});
    ['itemCatalog', 'fuelCardAction', 'mechanicAssetAction', 'employeeCatalogSubject', 'recurrence', 'fulfillment', 'excelExport']
        .forEach(key => { config[key] = {enabled: false}; });
    config.mechanicAssetActions = [];
    return config;
}
function normalizeReports(value) {
    if (typeof value === 'string') value = JSON.parse(value);
    const rows = value && value.reports;
    if (!Array.isArray(rows) || !rows.length || rows.length > 200) throw Error('Выберите от 1 до 200 отчётов одного объекта.');
    const ids = new Set();
    return rows.map(row => {
        const shift_id = Number(row.shift_id), reason = String(row.reason || row.cause || '').trim();
        if (!Number.isSafeInteger(shift_id) || shift_id <= 0 || ids.has(shift_id)) throw Error('Некорректные или повторяющиеся отчёты.');
        if (!reason || reason.length > 100) throw Error('Укажите причину аннулирования каждого отчёта (до 100 символов).');
        ids.add(shift_id);
        return {shift_id, reason};
    });
}
module.exports = {CATEGORY, ACTIONS, isAnnulment, normalizeWorkflow, normalizeReports};
